import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import MiniAngelScene from './MiniAngelScene';

const portfolioItems = [
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/r6mnxec3_copy_G6LC5546E64-719A-4C11-A108-740180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/y3jg05id_copy_10085E9B-3EA8-4B6B-BF41-045B21CC1761.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/lipkve30_copy_43D31953-E167-4540-A8B7-9B11E4DAAE53.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/56np1vg0_copy_3C776E64-719A-4C11-A108-730180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/mao308gk_copy_FF85277D-245D-4197-B291-6CC18FAECC79.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/j62oqh3z_copy_7DE992C5-216B-4A47-A805-78825E2C5E28.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/7bdgbgfr_copy_3RTB6E64-719A-4C11-A108-740180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/1vscofud_copy_260EEE0B-D0E0-424E-BB6F-7C9BB830E229.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/730e7r3r_copy_7UHN776E64-719A-4C11-A108-740180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/mlr7h3lc_copy_CAED24F1-1FDD-4B2B-81DF-2B39C899F624.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/swhyss1a_copy_4403A8A0-2AC4-4813-B784-68F5A8046A26.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/nyblglt2_copy_1C776E64-719A-4C11-A108-740180E719B7.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/58w59ema_copy_9H766E64-719A-4C11-A108-740180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/93iziroz_copy_D2476BD4-6625-4E03-A0AB-4B8D07A2CAA9.mp4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/yjzjmwph_copy_4fgvb6E64-719A-4C11-A108-740180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/hvs59j5c_copy_34G776E64-719A-4C11-A108-740180E719B7.MP4' },
  { video: 'https://customer-assets.emergentagent.com/job_ethereal-3d/artifacts/znnj4hcn_copy_2E8E5721-DDFB-4FCC-87D7-B8E167710D6A.mp4' },
];

function VideoCard({ item, index }) {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    const container = containerRef.current;
    if (!video || !container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      ref={containerRef}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: (index % 3) * 0.08, duration: 0.6 }}
      className="portfolio-item group cursor-pointer w-full"
      style={{ aspectRatio: '1 / 1' }}
      data-testid={`portfolio-item-${index}`}
    >
      {/* Loading indicator */}
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-[#0a0a0a] z-5">
          <div className="w-6 h-6 border border-white/20 border-t-white/60 rounded-full animate-spin" />
        </div>
      )}
      <video
        ref={videoRef}
        src={item.video}
        className="absolute inset-0 w-full h-full object-cover"
        loop
        muted
        playsInline
        autoPlay
        preload="auto"
        onLoadedData={() => setLoaded(true)}
        onCanPlay={() => setLoaded(true)}
      />
      <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-all duration-500 z-10" />
    </motion.div>
  );
}

export default function PortfolioSection() {
  return (
    <section id="portfolio" className="section-padding relative" data-testid="portfolio-section">
      <div className="section-divider mb-24" />
      <div className="hidden lg:block absolute top-32 left-5 z-0"><MiniAngelScene type="feather" size={160} /></div>
      <div className="hidden lg:block absolute bottom-10 right-16 z-0"><MiniAngelScene type="orb" size={140} /></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8 }}
          className="flex items-end justify-between mb-16"
        >
          <div>
            <p className="font-mono text-xs tracking-[0.3em] text-white/30 uppercase mb-4">Selected Work</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl">PORTFOLIO</h2>
          </div>
          <p className="font-mono text-xs text-white/20 hidden md:block">2023 — 2025</p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-3">
          {portfolioItems.map((item, i) => (
            <div key={i} className="w-[calc(50%-6px)] md:w-[calc(33.333%-8px)]">
              <VideoCard item={item} index={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
